import { z } from "zod";
export const MIGRATION_RUNS_COLLECTION_NAME = "migration_runs";
export const ZMigrationRunMongoDocument = z.object({
    _id: z.string().uuid(),
    migrationId: z.string(),
    status: z.enum(["running", "success", "failed"]),
    startedAt: z.string().datetime(),
    finishedAt: z.string().datetime().optional(),
    startedBy: z.string(),
    databaseName: z.string(),
    hosts: z.string(),
    logs: z.array(z.string()),
    error: z.string().optional(),
});
